var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n    "+_vm._s(_vm.event.title)+"\n  ")]),_c('event-form',{attrs:{"event":_vm.event}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }